import AOS from 'aos'
export default {
  init() {
    // JavaScript to be fired on all pages
    this.scrollHeader();
    this.phoneMask();
    this.magnificPopup();
    this.callModal();
    this.teamMore();
    this.feedbackTab();
    this.feedbackMore();
    this.formOptionPlaceholder();
  },

  scrollHeader() {
    $(document).ready(function() {
      AOS.init();
    });

    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $('.banner__wrapper').addClass('scrolled');
      } else {
        $('.banner__wrapper').removeClass('scrolled');
      }
    });

    // реагируем только на якоря внутри меню
    $(document).on('click', '.banner__nav-primary-list a[href*="#"]', function(){
      $('.banner__nav-primary--active').removeClass('banner__nav-primary--active');
      $('.banner .navi--active').removeClass('navi--active');
    });
  },

  phoneMask() {
    /*
    $('input[type="tel"]').mask('+39 999 999 999');
    */
  },

  magnificPopup() {
    /*$('.service-page__gallery-item-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });*/
  },

  callModal() {
    $('.button-btn').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper').fadeIn(250);
      $('#wpcf7-f270-o1').fadeIn(250);
      $('#wpcf7-f270-o2').fadeIn(250);
      $('#wpcf7-f270-o3').fadeIn(250);
      $('#wpcf7-f270-o4').fadeIn(250);
      $('#wpcf7-f270-o5').fadeIn(250);
      $('#wpcf7-f270-o6').fadeIn(250);
      $('#wpcf7-f270-o7').fadeIn(250);
      $('#wpcf7-f270-o8').fadeIn(250);
    });

    $('.front-page__service-item-button-0').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper-0').fadeIn(250);
      $('#wpcf7-f325-o1').fadeIn(250);
      $('#wpcf7-f325-o2').fadeIn(250);
      $('#wpcf7-f325-o3').fadeIn(250);
      $('#wpcf7-f325-o4').fadeIn(250);
      $('#wpcf7-f325-o5').fadeIn(250);
      $('#wpcf7-f325-o6').fadeIn(250);
      $('#wpcf7-f325-o7').fadeIn(250);
      $('#wpcf7-f325-o8').fadeIn(250);
    });

    $('.front-page__service-item-button-1').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper-1').fadeIn(250);
      $('#wpcf7-f334-o1').fadeIn(250);
      $('#wpcf7-f334-o2').fadeIn(250);
      $('#wpcf7-f334-o3').fadeIn(250);
      $('#wpcf7-f334-o4').fadeIn(250);
      $('#wpcf7-f334-o5').fadeIn(250);
      $('#wpcf7-f334-o6').fadeIn(250);
      $('#wpcf7-f334-o7').fadeIn(250);
      $('#wpcf7-f334-o8').fadeIn(250);
    });

    $('.front-page__service-item-button-2').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper-2').fadeIn(250);
      $('#wpcf7-f342-o1').fadeIn(250);
      $('#wpcf7-f342-o2').fadeIn(250);
      $('#wpcf7-f342-o3').fadeIn(250);
      $('#wpcf7-f342-o4').fadeIn(250);
      $('#wpcf7-f342-o5').fadeIn(250);
      $('#wpcf7-f342-o6').fadeIn(250);
      $('#wpcf7-f342-o7').fadeIn(250);
      $('#wpcf7-f342-o8').fadeIn(250);
    });

    $('.modal__wrapper, .modal__wrapper-0, .modal__wrapper-1, .modal__wrapper-2, .modal__block-close-modal, .modal__block-close-modal-0, .modal__block-close-modal-1, .modal__block-close-modal-2').on('click', (e) => {
      if ($(e.target).hasClass('modal__wrapper') || $(e.target).hasClass('modal__wrapper-0') || $(e.target).hasClass('modal__wrapper-1') || $(e.target).hasClass('modal__wrapper-2') || $(e.target).hasClass('modal__block-close-modal') || $(e.target).hasClass('modal__block-close-modal-0') || $(e.target).hasClass('modal__block-close-modal-1') || $(e.target).hasClass('modal__block-close-modal-2')) {
        $('.modal__wrapper').fadeOut(250);
        $('.modal__wrapper-0').fadeOut(250);
        $('.modal__wrapper-1').fadeOut(250);
        $('.modal__wrapper-2').fadeOut(250);
        $('.modal__block > .wpcf7').fadeOut(250);
      }
    });
  },

  teamMore() {
    $('.front-page__team-item').each(function () {
      const $item = $(this);
      const $text = $item.find('.front-page__team-item-text');
      const $btn = $item.find('.front-page__team-item-more');

      const $paragraphs = $text.find('p');

      // Нужно минимум 3 абзаца (2 видно + 1 скрыт)
      if ($paragraphs.length < 3) return;

      // Определяем язык страницы
      const lang = $('html').attr('lang') || 'ru';

      const texts = {
        ru: { more: 'Читать дальше', less: 'Скрыть' },
        en: { more: 'Read more', less: 'Hide' },
        es: { more: 'Leer más', less: 'Esconder' },
        ca: { more: 'Llegir més', less: 'Amaga' },
      };

      const t = texts[lang] || texts.ru;

      $btn.text(t.more).show();

      // Высота первых 2 абзацев
      let collapsedHeight = 0;
      $paragraphs.slice(0, 2).each(function () {
        collapsedHeight += $(this).outerHeight(true);
      });

      const fullHeight = $text.outerHeight(true);

      // Изначально свернуто
      $text.css({
        'max-height': collapsedHeight,
        'overflow': 'hidden',
        'transition': 'max-height 0.4s ease',
      });

      let expanded = false;

      $btn.on('click', function () {
        if (!expanded) {
          $text.css('max-height', fullHeight);
          $btn.text(t.less);
          expanded = true;
        } else {
          $text.css('max-height', collapsedHeight);
          $btn.text(t.more);
          expanded = false;
        }
      });
    });
  },

  feedbackTab() {
    $('.front-page__feedback-tabs_btn:nth-of-type(1)').addClass('active');
    $('.front-page__feedback-block:nth-of-type(1)').addClass('active');
    $('.front-page__feedback-tabs_btn').click(function () {
      $('.front-page__feedback-tabs_btn').removeClass('active');
      $(this).toggleClass('active');
      $('.front-page__feedback-block').removeClass('active');
      $('.front-page__feedback-block[data-name=' + $(this).data('name') + ']').addClass('active');
    });
  },

  feedbackMore() {
    $('.front-page__feedback-item-review_el').each(function () {
      const $item = $(this);
      const $text = $item.find('.front-page__feedback-item-review_el-text');
      const $btn = $item.find('.front-page__feedback-item-review_el-more');

      const $paragraphs = $text.find('p');
      if ($paragraphs.length < 2) return;

      const lang = $('html').attr('lang') || 'ru';

      const texts = {
        ru: { more: 'Читать весь отзыв', less: 'Скрыть' },
        en: { more: 'Read the full review', less: 'Hide' },
        es: { more: 'Lea la reseña completa', less: 'Esconder' },
        ca: { more: 'Llegeix la ressenya completa', less: 'Amaga' },
      };

      const t = texts[lang] || texts.ru;

      $btn.text(t.more).show();

      /* ===== высота первых 2 абзацев ===== */
      let collapsedHeight = 0;
      $paragraphs.slice(0, 2).each(function () {
        collapsedHeight += this.offsetHeight;
      });

      $text.css({
        maxHeight: collapsedHeight + 'px',
        overflow: 'hidden',
        transition: 'max-height 0.4s ease',
      });

      let expanded = false;

      $btn.on('click', function () {
        if (!expanded) {
          // ⚠️ ВСЕГДА берём реальную высоту
          const fullHeight = $text[0].scrollHeight;

          $text.css('max-height', fullHeight + 'px');
          $btn.text(t.less);
          expanded = true;
        } else {
          $text.css('max-height', collapsedHeight + 'px');
          $btn.text(t.more);
          expanded = false;
        }
      });

      $text.one('transitionend', () => {
        if (expanded) {
          $text.css('max-height', 'none');
        }
      });
    });

    /*$
    ('.front-page__feedback-item-review_el').each(function () {
      const $item = $(this);
      const $text = $item.find('.front-page__feedback-item-review_el-text');
      const $btn = $item.find('.front-page__feedback-item-review_el-more');

      const $paragraphs = $text.find('p');

      // Нужно минимум 3 абзаца (2 видно + 1 скрыт)
      if ($paragraphs.length < 1) return;

      // Определяем язык страницы
      const lang = $('html').attr('lang') || 'ru';

      const texts = {
        ru: { more: 'Читать весь отзыв', less: 'Скрыть' },
        en: { more: 'Read the full review', less: 'Hide' },
        es: { more: 'Lea la reseña completa', less: 'Esconder' },
        ca: { more: 'Llegeix la ressenya completa', less: 'Amaga' },
      };

      const t = texts[lang] || texts.ru;

      $btn.text(t.more).show();

      // Высота первых 2 абзацев
      let collapsedHeight = 0;
      $paragraphs.slice(0, 2).each(function () {
        collapsedHeight += $(this).outerHeight(true);
      });

      const fullHeight = $text.outerHeight(true);

      // Изначально свернуто
      $text.css({
        'max-height': collapsedHeight,
        'overflow': 'hidden',
        'transition': 'max-height 0.4s ease',
      });

      let expanded = false;

      $btn.on('click', function () {
        if (!expanded) {
          $text.css('max-height', fullHeight);
          $btn.text(t.less);
          expanded = true;
        } else {
          $text.css('max-height', collapsedHeight);
          $btn.text(t.more);
          expanded = false;
        }
      });
    });
    */
  },

  formOptionPlaceholder() {
    $('.wpcf7-select').on('change', function() {
      $(this).css('color', '#144643');
    });
    // Topic of the inquiry
    $('.user-menu-05').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-05').children('.wpcf7-select').children('option:contains("---")').html('Удобный способ связи');

    $('.user-menu-06').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-06').children('.wpcf7-select').children('option:contains("---")').html('Convenient way of communication');

    $('.user-menu-07').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-07').children('.wpcf7-select').children('option:contains("---")').html('Una forma cómoda de comunicación');

    $('.user-menu-08').children('.wpcf7-select').children('option:contains("---")').attr('disabled','disabled');
    $('.user-menu-08').children('.wpcf7-select').children('option:contains("---")').html('Forma convenient de comunicació');
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.navi').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('navi--active');
      $('.banner__nav-primary').toggleClass('banner__nav-primary--active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js